import React, { useMemo } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { RichTextEditorStyled } from './rich-text-editor.styles';

const TOOLBAR_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
  ],
};

const FORMATS = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'list',
  'bullet',
  'indent',
];

const EMPTY_VALUE = '<p><br></p>';

const RichTextEditor = ({
  value = '',
  onChange,
  readOnly = false,
  disabled = false,
  placeholder = '',
  className = '',
}) => {
  const isReadOnly = readOnly || disabled;

  const modules = useMemo(() => (isReadOnly ? { toolbar: false } : TOOLBAR_MODULES), [isReadOnly]);

  const handleChange = (content) => {
    if (!onChange) return;
    const normalised = content === EMPTY_VALUE ? '' : content;
    onChange(normalised);
  };

  return (
    <RichTextEditorStyled className={className} isReadOnly={isReadOnly}>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={handleChange}
        modules={modules}
        formats={FORMATS}
        placeholder={placeholder}
        readOnly={isReadOnly}
      />
    </RichTextEditorStyled>
  );
};

export default RichTextEditor;
